import ApiService from '../api.service'

const ItemUomOverrideService = {
    getList: async (payload) => {
        const requestData = {
            method: 'post',
            url: '/api/ItemUomOverride/GetList',
            data: payload,
        }
        try {
            const response = await ApiService.customRequest(requestData)
            return response.data
        } catch (ex) {
            throw ex
        }
    },
    save: async (payload) => {
        const requestData = {
            method: 'post',
            url: '/api/ItemUomOverride/Save',
            data: payload,
        }
        try {
            const response = await ApiService.customRequest(requestData)
            return response.data
        } catch (ex) {
            throw ex
        }
    },
    sync: async () => {
        const requestData = {
            method: 'post',
            url: '/api/ItemUomOverride/Sync',
        }
        try {
            const response = await ApiService.customRequest(requestData)
            return response.data
        } catch (ex) {
            throw ex
        }
    },
}

export default ItemUomOverrideService
